import { useMediaQuery } from 'react-responsive';
import { breakpoints } from './utils/breakpoints';

export const Desktop = ({ children }) => {
	const isDesktop = useMediaQuery({ minWidth: breakpoints.lg.min });
	return isDesktop ? children : null;
};
